var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-item",attrs:{"active-class":"underline-active","to":{ name: _vm.title }}},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}}),_c('span',[_vm._v(_vm._s(_vm.$t(("navigation." + _vm.title))))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }